import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';

import {
  BackdropForDialog,
  CloseButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  SubmitButton,
} from 'components';
import { EmployeeForm } from 'forms';

interface EmployeeUpdateDialogProps {
  visible?: boolean;
  setVisible?: (visible: boolean) => void;
  title?: string;
  subtitle?: string;
  submitButtonLabel?: string;
  employeeId: number;
}

export const EmployeeUpdateDialog = ({
  visible = false,
  setVisible = () => {},
  title = 'Update cleaning professional',
  subtitle = 'Add the information below',
  submitButtonLabel = 'Update',
  employeeId,
}: EmployeeUpdateDialogProps) => {
  const [loading_form, setLoadingForm] = useState<boolean>(false);
  const [loading_submit, setLoadingSubmit] = useState<boolean>(false);

  const formRef = React.useRef<any>();

  const onClose = (event: any, reason: string) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setVisible(false);
      document.body.removeAttribute('style');
    }
  };

  const onSubmit = () => {
    formRef.current.onSubmit();
  };

  return (
    <Dialog
      onClose={onClose}
      open={visible}
      PaperProps={{ sx: { marginBottom: 12, overflow: 'unset', position: 'relative' } }}
    >
      <DialogTitle>
        <Box>
          <Typography variant="h5">{title}</Typography>

          <Typography
            variant="body2"
            color="textSecondary"
            sx={{
              marginTop: 1,
            }}
          >
            {subtitle}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box paddingTop={2}>
          <EmployeeForm
            ref={formRef}
            employeeId={employeeId}
            onInit={(loading) => setLoadingForm(loading)}
            onSubmitting={(loading) => setLoadingSubmit(loading)}
            next={() => {
              setVisible(false);
            }}
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <SubmitButton loading={loading_submit} label={submitButtonLabel} onClick={onSubmit} />
      </DialogActions>

      <CloseButton onClick={() => onClose(null, 'anyway')} sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }} />

      <BackdropForDialog loading={loading_form} />
    </Dialog>
  );
};
